<template>
  <vs-popup class="user-edit-popup" title="Export - Project Brief Completion Rate" @close="onClickClose" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(download)" autocomplete="off">
          <vx-card noShadow>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full">
                <ValidationProvider name="from" rules="required" v-slot="{ errors }">
                  <small class="label">Date From</small>
                  <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="form.from" placeholder="Choose Date" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full">
                <ValidationProvider name="to" rules="required" v-slot="{ errors }">
                  <small class="label">Date To</small>
                  <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="form.to" placeholder="Choose Date" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full">
                <ValidationProvider name="interval" rules="required" v-slot="{ errors }">
                  <small class="label">Interval</small>
                  <v-select v-model="form.interval" :options="intervalOptions" :reduce="o => o.value" label="name"
                    :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button icon-pack="feather" icon="icon-download" button="submit" class="mt-2 ml-2">Download</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import ErrorMessages from '@/mixins/ErrorMessages'
const ReportingRepository = RepositoryFactory.get('reporting')

export default {
  name: 'ProjectBriefReportExportPopUp',
  data() {
    return {
      open: false,
      form: { from: null, to: null, interval: 'monthly' },
      intervalOptions: [
        { name: 'Weekly', value: 'weekly' },
        { name: 'Monthly', value: 'monthly' },
        { name: 'Yearly', value: 'yearly' },
      ],
    }
  },
  mixins: [ErrorMessages],
  components: { flatPickr, 'v-select': vSelect },
  methods: {
    openPopup(from, to) {
      this.form = { from: from || null, to: to || null, interval: 'monthly' }
      this.open = true
    },
    async download() {
      this.$vs.loading()
      try {
        const params = `from=${encodeURIComponent(this.form.from)}&to=${encodeURIComponent(this.form.to)}&interval=${this.form.interval}`
        const response = await ReportingRepository.downloadExcelSheetData('report/project-brief-completion-rate', params)
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'Project Brief Completion Rate.xlsx')
        document.body.appendChild(fileLink)
        fileLink.click()
        this.open = false
      } catch (e) {
        this.$vs.dialog({
          type: 'alert', color: 'warning', title: 'No Data Found',
          text: 'There are no records available for the selected filters. Please adjust your filters and try again.',
          acceptText: 'OK',
        })
      }
      this.$vs.loading.close()
    },
    onClickClose() {
      this.open = false
    },
  },
}
</script>
